"use client";

import { Button } from "@/app/components/shadcn/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/app/components/shadcn/tooltip";
import useModal from "@/app/lib/features/modal/modal.hook";
import { FloatingMenuItem } from "@/app/lib/features/floatingContent/floatingContent.types";
import { trackGeneric } from "@/app/lib/tracking/interactions";
import FallbackImage from "@/app/components/elements/FallbackImage";

interface SpinWheelButtonProps {
  item?: FloatingMenuItem;
}

const SpinWheelButton = ({ item }: SpinWheelButtonProps) => {
  const { createModal } = useModal();

  const label = item?.title ?? "Çarkıfelek";
  const icon = item?.icon;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          onClick={() => { trackGeneric("spin_wheel"); createModal("spin-wheel"); }}
          className="w-10 sm:w-11 lg:w-12 h-10 sm:h-11 lg:h-12 bg-black hover:bg-neutral-800 rounded-xl p-0 shadow-md transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 text-lg"
          style={{ backgroundColor: "#f2791c" }}
        >
          {icon ? (
            <FallbackImage
              src={icon}
              alt={label}
              width={24}
              height={24}
              className="object-contain"
            />
          ) : (
            "🎡"
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="right">
        <p>{label}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default SpinWheelButton;
